import { render } from "./UpdateArtistPage.vue?vue&type=template&id=f738002c"
import script from "./UpdateArtistPage.vue?vue&type=script&lang=js"
export * from "./UpdateArtistPage.vue?vue&type=script&lang=js"

import "./UpdateArtistPage.vue?vue&type=style&index=0&id=f738002c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__